import React from 'react';

import {LogoSvg} from '../svgs';
import Socials from "./elements/About/Socials";

const Footer = ({translate, api}) => {
	const {socials, copyright: {text, params}} = api.getFooter();

	return (
		<footer className="root-sec footer-wrap">
			<div className="container">
				<div className="row">
					<div className="col m3"/>
					<div className="col m6">
						<div className="user-social">
							<div className="logo text-center">
								<a href="#home" data-section="#home" className="brand-logo smooth-scroll">
									<LogoSvg scale={.45}/>
								</a>

								<Socials {...socials} />
							</div>
						</div>
					</div>
					<div className="col m3"/>
				</div>
			</div>
			<div className="container-fluid">
				<hr/>
				<div className="row">
					<div className="col s12">
						<p className="copyright text-center">{translate(text, params)}</p>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js